/**
 * Email de Confirmação de Cadastro com OTP
 * Template usado para enviar o código de verificação durante o cadastro do premiado.
 */

import { montarBase } from './EmailBase';

export interface EmailConfirmacaoCadastroParams {
  nome: string;
  codigoOTP: string;
  email: string;
  minutosExpiracao?: number;
}

export function gerarEmailConfirmacaoCadastro(params: EmailConfirmacaoCadastroParams): string {
  const minutos = params.minutosExpiracao ?? 10;

  const conteudo = `
    <p style="margin: 0 0 16px 0; font-size: 15px; color: #475569; line-height: 1.7;">
      Para concluir seu cadastro na plataforma <strong style="color: #F97316;">GetPoints</strong>, utilize o código de verificação abaixo.
      Esta é uma medida de segurança para garantir a autenticidade da sua conta.
    </p>

    <!-- Bloco do Código OTP -->
    <table width="100%" cellpadding="0" cellspacing="0" style="margin: 28px 0;">
      <tr>
        <td align="center">
          <table cellpadding="0" cellspacing="0" style="background-color: #FFF7ED; border: 2px dashed #F97316; border-radius: 12px; padding: 24px 40px;">
            <tr>
              <td align="center">
                <p style="margin: 0 0 8px 0; font-size: 12px; font-weight: 700; color: #9A3412; text-transform: uppercase; letter-spacing: 2px;">Código de Verificação</p>
                <p style="margin: 0; font-size: 40px; font-weight: 800; color: #EA580C; letter-spacing: 10px; font-family: 'Courier New', Courier, monospace;">
                  ${params.codigoOTP}
                </p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <p style="margin: 0 0 16px 0; font-size: 14px; color: #64748B; line-height: 1.6;">
      Digite este código na tela de validação do cadastro para confirmar seu e-mail <strong style="color: #334155;">${params.email}</strong>.
      Não compartilhe este código com ninguém.
    </p>

    <!-- Informações de Segurança -->
    <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 20px; background-color: #F1F5F9; border-radius: 8px; padding: 16px 20px;">
      <tr>
        <td>
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td style="vertical-align: top; padding-right: 10px;">
                <span style="font-size: 16px; color: #64748B;">&#128274;</span>
              </td>
              <td style="font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;">
                <p style="margin: 0 0 4px 0; font-size: 13px; font-weight: 700; color: #334155;">Dica de Segurança</p>
                <p style="margin: 0; font-size: 12px; color: #64748B; line-height: 1.5;">
                  A GetPoints <strong>nunca</strong> solicitará este código por telefone, SMS ou WhatsApp.
                  Caso receba alguma solicitação suspeita, ignore e entre em contato conosco.
                </p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `;

  return montarBase({
    titulo: 'Confirmação de Cadastro',
    saudacao: `Olá, <strong style="color: #1E293B;">${params.nome}</strong>!`,
    conteudo,
    prazoExpiracao: `Este código expira em <strong>${minutos} minutos</strong>. Após o prazo, será necessário solicitar um novo código na página de cadastro.`,
  });
}